// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2N0sx","paramInput":"JobSimulator_paramInput__1ekbg","input":"JobSimulator_input__NX6Iz"};